<template>
	<div class="pa-3 pb-5">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-form ref="form" v-model="valid" class="pb-5" lazy-validation>
			<v-tabs v-model="toggle.activeTab" color="grey lighten-5">
				<v-tab :key="1" ripple>General</v-tab>
				<v-tab :key="2" ripple>Prizes</v-tab>
				<v-tab :key="3" ripple v-if="item.candidatesCount">Candidates</v-tab>
				<v-tab :key="4" ripple v-if="item.candidatesCount && item.prizes.length">Winners</v-tab>
				<v-tab :key="5" ripple v-if="item.candidatesCount && item.prizes.length">Report</v-tab>

				<v-tab-item :key="1">
					<v-card flat class="mb-5">
						<v-card-text>
							<v-switch v-model="item.published" label="Publish"></v-switch>
							<v-text-field v-model="item.title" label="Title" :rules="rules.text" required></v-text-field>
							<v-textarea v-model="item.description" label="Description" :rules="rules.text" required></v-textarea>
							<v-text-field type="number" class="boxes-input" v-model="item.boxes" label="Boxes" prepend-icon="fas fa-boxes" :rules="rules.number" required></v-text-field>
							<v-menu offset-y :close-on-content-click="false" v-model="toggle.dateMenu" bottom>
								<v-text-field class="validity-input" v-model="validity" readonly slot="activator" label="Validity Period" prepend-icon="event" :rules="rules.text" required></v-text-field>
								<v-card>
									<v-card-text>
										<date-range-picker v-model="validityPeriod"></date-range-picker>
										<!-- <v-daterange :no-presets="true" :options="rangePickerOptions" @input="handlePeriodChanged"></v-daterange> -->
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer><v-btn flat @click="toggle.dateMenu = false">Close</v-btn>
									</v-card-actions>
								</v-card>
							</v-menu>
							<v-flex xs12>
								<schedule-picker v-model="item.prizeDrawingDate" :text-label="'วันคัดรางวัล'" :prepend-inner-icon="''" :prepend-icon="'event'" :allow-null="true"></schedule-picker>
							</v-flex>
							<v-flex xs12>
								<schedule-picker v-model="item.announcementDate" :text-label="'วันประกาศผล'" :prepend-inner-icon="''" :prepend-icon="'event'" :allow-null="true"></schedule-picker>
							</v-flex>
							<cover-image-upload label="Cover Image" v-model="item.coverUrl"></cover-image-upload>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="2">
					<v-card flat class="mb-5 activity-prizes">
						<v-card-title primary-title>
							<h1 class="headline">Prizes</h1>
						</v-card-title>

						<v-card-text class="prize-list">
							<template v-for="type in prizeTypes">
								<!--
								<h2>{{ type.title }}</h2>
								-->
								<ol class="prizes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<prize-edit 
											v-model="item.prizes[item.prizes.indexOf(prize)]"
											:disable-move-up="prize.seqNo == 1" 
											:disable-move-down="prize.seqNo == Math.max.apply(Math, item.prizes.filter(p => p.type == prize.type).map(function(o) { return o.seqNo; }))"
											@moveUp="handlePrizeMoveUp(prize)"
											@moveDown="handlePrizeMoveDown(prize)"
											@remove="handlePrizeRemove(prize)">
										</prize-edit>
									</li>
								</ol>

								<v-flex xs12>
									<v-btn color="secondary" @click="handlePrizeAdd(type.type)">Add</v-btn>
								</v-flex>

								<v-divider class="mt-3 mb-4"></v-divider>
							</template>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="3" v-if="item.candidatesCount">
					<v-card flat class="mb-5 activity-candidates">
						<v-card-title primary-title>
							<h1 class="headline">Candidates</h1>
						</v-card-title>

						<v-card-text>
							<candidates-table :giveaway-box-id="item.id"></candidates-table>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="4" v-if="item.candidatesCount && item.prizes.length">
					<v-card flat class="mb-5 activity-winners">
						<v-card-title primary-title>
							<h1 class="headline">Winners</h1>
						</v-card-title>

						<v-card-text>
							<v-card>
								<v-card-text>
									<v-switch v-model="item.announced" label="ประกาศผลรางวัล"></v-switch>
									<date-time-picker v-if="item.announced" v-model="item.announcedAt"></date-time-picker>
								</v-card-text>
							</v-card>
						</v-card-text>

						<v-card-text class="prize-winner-list">

							<template v-for="type in prizeTypes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.filter(p => p.type == type.type).length">
								<!--
								<h2>{{ type.title }}</h2>
								-->

								<ol class="prizes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<h3 class="title mb-2">{{ prize.title }}</h3>
										<p class="body-2" v-if="prize.description">{{ prize.description }}</p>

										<template v-if="prize.hasOwnProperty('winners') && Array.isArray(prize.winners)">

										<div class="mb-4" v-if="prize.winners.length">
											<v-chip class="text-xs-center subtitle mb-2" close v-for="winner in prize.winners" @input="handleWinnerRemove(winner)">
												<v-avatar>
													<img :src="winner.user.avatar" :alt="winner.user.username">
												</v-avatar>
												{{ winner.user.username }}
											</v-chip>
										</div>

										<v-btn :disabled="prize.winners.length >= prize.numberOfWinners" class="ma-0" color="secondary" @click="handleWinnersChoose(prize)">Choose Winners</v-btn>
										<winners-csv :prize-id="prize.id" :flat="true" :color="'secondary'" :file-title="prize.title">Export</winners-csv>

										</template>
									</li>
								</ol>

								<v-divider class="mt-3 mb-4"></v-divider>
							</template>

						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="5" v-if="item.candidatesCount && item.prizes.length">
					<v-card flat class="mb-5 activity-winners">
						<v-card-title primary-title>
							<h1 class="headline">Report</h1>
						</v-card-title>

						<v-card-text class="prize-winner-list">

							<template v-for="type in prizeTypes" v-if="item && item.prizes && Array.isArray(item.prizes) && item.prizes.filter(p => p.type == type.type).length">
								<h2>{{ type.title }}</h2>

								<ol class="prizes" v-if="prizeReports && item && item.prizes && Array.isArray(item.prizes) && item.prizes.length">
									<li class="pb-5" v-for="(prize, index) in item.prizes.filter(p => p.type == type.type).sort((a, b) => a.seqNo - b.seqNo)" :data-prefix="type.type.substring(0, 1)" :data-seq="prize.seqNo">
										<h3 class="title mb-2">{{ prize.title }}</h3>
										<p class="body-2" v-if="prize.description">{{ prize.description }}</p>

										<prize-performance v-for="data in prizeReports.filter(z => z.id == prize.id)" :data="data"></prize-performance>
									</li>
								</ol>
							</template>

						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>

			<v-footer fixed flat height="auto" color="grey lighten-2 px-3">
				<v-layout row wrap>
					<v-btn color="primary" @click="handleSave" :disabled="!valid">Save</v-btn>
					<v-btn flat @click="handleCancel">Cancel</v-btn>
				</v-layout>
			</v-footer>
		</v-form>

		<winners-choose 
			:prize="prizeToBeChoosed" 
			:candidates="candidates" 
			:ignored-user-ids="selectedCandidateIds"
			@close="prizeToBeChoosed = null" 
			@selected="handleWinnersSelected">
		</winners-choose>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import DateRangePicker from '@/components/DateRangePicker.vue'
	import DateTimePicker from '@/components/DateTimePicker.vue'
	import CoverImageUpload from '@/components/CoverImageUpload.vue'
	import SchedulePicker from '@/components/SchedulePicker.vue'

	import ImageUpload from '@/components/ImageUpload.vue'
	import PrizeEdit from '@/components/PrizeEdit.vue'
	import RelatedProducts from '@/components/RelatedProducts.vue'
	import CandidatesTable from '@/views/giveaway-box/CandidatesTable.vue'
	
	import WinnersChoose from '@/components/WinnersChoose.vue'
	import WinnersCsv from '@/components/WinnersCsv.vue'

	import PrizePerformance from '@/components/PrizePerformance.vue'

	export default {
		components: {
			'date-range-picker': DateRangePicker,
			'date-time-picker': DateTimePicker,
			'cover-image-upload': CoverImageUpload,
			'schedule-picker': SchedulePicker,
			'image-upload': ImageUpload,
			'prize-edit': PrizeEdit,
			'related-products': RelatedProducts,
			'winners-choose': WinnersChoose,
			'winners-csv': WinnersCsv,
			'candidates-table': CandidatesTable,
			'prize-performance': PrizePerformance
		},
		data () {
			let prizeType = {
				LUCKY: 'LUCKY'
			}

			return {
	        	apiUrl: `${config.BASE_URL}/giveawayBox`,
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Giveaway Boxes',
						disabled: false,
						href: `${config.PUBLIC_PATH}giveaway-box`
					}
				],
				valid: true,
				validityPeriod: {
					startDate: null,
					endDate: null
				},
				item: {
			        id: 0,
			        title: '',
					description: '',
					boxes: 0,
					coverUrl: '',
					responsiveCoverFile: '',
					externalLink: '',
					couponTitle1: '-',
					couponTitle2: '-',
					startDate: null,
					endDate: null,
					discountThumbnailUrl: '',
					prizeDrawingDate: null,
					announcementDate: null,
					published: 0,
					publishedOn: null,
					announced: false,
					announcedAt: null,
					candidatesCount: 0,
					prizes: []
				},
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},
				prizeType: prizeType,
				prizeTypes: [
					{
						type: prizeType.LUCKY,
						title: 'Lucky Draw'
					}
				],
				toggle: {
					dateMenu: false,
					activeTab: 0
				},
				ts: new Date().getTime(),

				emptyCriteria: {
					selects: [],
					genders: [],
					ages: [0, 0],
					skinTones: [],
					skinConditions: [],
					hairColors: [],
					hairConditions: [],
					skinProblems: [],
					skinProblemsAll: 0,
					bodyProblems: [],
					bodyProblemsAll: 0,
					hairProblems: [],
					hairProblemsAll: 0,
        		},

        		prizeToBeChoosed: null,
        		candidates: [],
        		prizeReports: []
			}
		},
		computed: {
			validity () 
			{
				return (this.validityPeriod.startDate && this.validityPeriod.endDate) ? `${this.validityPeriod.startDate} to ${this.validityPeriod.endDate}` : ''
			},
			selectedCandidateIds () 
			{
				return this.item.prizes.reduce((accumulator, value) => (value.hasOwnProperty('winners')) ? accumulator.concat(value.winners.map(w => w.userId)) : [], [])
			}
		},
		methods: {
			handleCancel ()
			{
				this.$router.push({'path': `${config.PUBLIC_PATH}giveaway-box`})
			},
			handleStartDateInput () 
			{
				this.toggle.startDate = false
				if (!this.item.endDate) {
					this.item.endDate = this.item.startDate
					this.toggle.endDate = true
				}
			},
		    handleSave () 
		    {
		    	if (this.$refs.form.validate()) {
		    		if (!this.item.coverUrl) {
		    			this.$store.commit(types.SET_ERROR_MSG, "Please upload cover image.")
		    			return false;
		    		}
		    		this.item.responsiveCoverFile = this.item.coverUrl.substring(this.item.coverUrl.lastIndexOf('/') + 1).replace('.jpeg', '.jpg').replace('.png', '.jpg')

		    		this.item.startDate = this.validityPeriod.startDate
		    		this.item.endDate = this.validityPeriod.endDate

			    	if (this.item.id) {
				    	axios.put(`${this.apiUrl}/${this.item.id}`, this.item)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				// this.$router.push({ path: `${config.PUBLIC_PATH}giveaway-box` })
									this.$store.commit(types.SET_SUCCESS_MSG, "Update completed")
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	} else {
				    	axios.post(this.apiUrl, this.item)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				// this.$router.push({ path: `${config.PUBLIC_PATH}giveaway-box` })
									this.$store.commit(types.SET_SUCCESS_MSG, "Update completed")
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	}
			    }
		    },

	        handlePrizeAdd (t) 
	        {
	        	let maxSeq = 0
	        	if (this.item.prizes.filter(p => p.type == t).length) {
		        	maxSeq = Math.max.apply(Math, this.item.prizes.filter(p => p.type == t).map(function(o) { return o.seqNo; }))
	        	}

	        	this.item.prizes.push({
	        		id: null,
	        		contentType: 'GIVEAWAY',
	        		contentId: this.item.id,
	        		type: t,
	        		title: this.item.title,
	        		description: this.item.description,
	        		imageUrl: null,
	        		numberOfWinners: this.item.boxes,
	        		seqNo: (maxSeq + 1),
	        		products: [],
	        		winners: [],
	        		criteria: JSON.parse(JSON.stringify(this.emptyCriteria)),
	        	})
	        },
	        handlePrizeMoveUp (prize)
	        {
	        	let siblingIndex = JSON.parse(JSON.stringify(this.item.prizes.indexOf(this.item.prizes.filter(p => p.type == prize.type && p.seqNo < prize.seqNo).sort((a, b) => b.seqNo - a.seqNo)[0])))

	        	this.item.prizes[siblingIndex].seqNo++
	        	prize.seqNo--

	        	this.ts = new Date().getTime()
	        },
	        handlePrizeMoveDown (prize)
	        {
	        	let siblingIndex = JSON.parse(JSON.stringify(this.item.prizes.indexOf(this.item.prizes.filter(p => p.type == prize.type && p.seqNo > prize.seqNo).sort((a, b) => a.seqNo - b.seqNo)[0])))

	        	this.item.prizes[siblingIndex].seqNo--
	        	prize.seqNo++

	        	this.ts = new Date().getTime()
	        },
	        handlePrizeRemove (prize) 
	        {
				this.$swal({
					title: 'Are you sure?',
					text: "Delete Prize ?",
					icon: 'warning',
					showCancelButton: true
				}).then(response => {
					if (response.value) {
			        	let prizeType = prize.type

			        	this.item.prizes.splice(this.item.prizes.indexOf(prize), 1)
			        	this.$nextTick(() => {
				        	this.prizesResequence(prizeType)
			        	})
					}
				})
	        },
	        prizesResequence (prizeType)
	        {
	        	let seqNo = 1;
	        	this.item.prizes.filter(p => p.type == prizeType).sort((a, b) => a.seqNo - b.seqNo).forEach(prize => {
	        		let prizeIndex = this.item.prizes.indexOf(prize)
	        		this.item.prizes[prizeIndex].seqNo = seqNo
	        		seqNo++
	        	})
	        },

			handleWinnersChoose (prize) {
				this.prizeToBeChoosed = prize
			},
			handleWinnersSelected (candidates) {
	        	let maxSeq = 0
	        	if (this.prizeToBeChoosed.winners.length) {
		        	maxSeq = Math.max.apply(Math, this.prizeToBeChoosed.winners.map(function(o) { return o.seqNo }))
	        	}

	        	candidates.forEach(c => {
	        		maxSeq++

					this.prizeToBeChoosed.winners.push({
						userId: c.userId,
						title: c.username,
						user: {
							id: c.userId,
							username: c.username,
							avatar: c.avatar
						},
						seqNo: maxSeq
					})
	        	})

	        	this.prizeToBeChoosed = null
			},
			handleWinnerRemove (winner) {
				this.$swal({
					title: 'Are you sure?',
					text: `Remove ${winner.title}`,
					icon: 'warning',
					showCancelButton: true
				}).then(response => {
					if (response.value) {
						this.item.prizes.forEach((p, pIdx) => {
							if (p.winners.indexOf(winner) >= 0) {
								this.item.prizes[pIdx].winners.splice(p.winners.indexOf(winner), 1)
							}
						})
					}
				})	        		
			},
			reloadCandidates () {
				axios.get(`${config.BASE_URL}/giveawayBox/${this.$route.params.id}/candidatesWithProfile`)
					.then(response => {
						this.candidates = response.data.data
					})
			},

			setItem(item) {
				if (item.hasOwnProperty('prizes') && Array.isArray(item.prizes) && item.prizes.length) {
					item.prizes.forEach((prize, index) => {
						if (!prize.hasOwnProperty('criteria') || !prize.criteria) {
							item.prizes[index].criteria = JSON.parse(JSON.stringify(this.emptyCriteria))
						} else {
							item.prizes[index].criteria.selects = []
							if (item.prizes[index].criteria.genders.length) item.prizes[index].criteria.selects.push('gender')
							if ((item.prizes[index].criteria.ages[0] > 0) && (item.prizes[index].criteria.ages[1] > 0)) item.prizes[index].criteria.selects.push('age')
							if (item.prizes[index].criteria.skinTones.length) item.prizes[index].criteria.selects.push('skinTone')
							if (item.prizes[index].criteria.skinConditions.length) item.prizes[index].criteria.selects.push('skinCondition')
							if (item.prizes[index].criteria.hairColors.length) item.prizes[index].criteria.selects.push('hairColor')
							if (item.prizes[index].criteria.hairConditions.length) item.prizes[index].criteria.selects.push('hairCondition')
							if (item.prizes[index].criteria.skinProblems.length) item.prizes[index].criteria.selects.push('skinProblem')
							if (item.prizes[index].criteria.bodyProblems.length) item.prizes[index].criteria.selects.push('bodyProblem')
							if (item.prizes[index].criteria.hairProblems.length) item.prizes[index].criteria.selects.push('hairProblem')
						}
					})
				}

				this.item = item
			},
			reloadReport () {
				axios.get(`${config.BASE_URL}/luckylist/prize/performanceReport?prize=${this.item.prizes.map(p => p.id).join(',')}`)
					.then(response => {
						this.prizeReports = response.data.data
					})
			}
		},
		mounted () {
		    if (this.$route.params.id !== undefined) {
		    	axios.get(`${this.apiUrl}/${this.$route.params.id}/data`)
		    		.then((response) => {
		    			this.setItem(response.data.data)
		    			this.reloadCandidates()

		    			this.validityPeriod.startDate = this.item.startDate
		    			this.validityPeriod.endDate = this.item.endDate

						this.breadcrumbs.push({
							text: this.item.title,
							disabled: true,
							href: ''
						})
		    		})
		    }
		},
		watch: {
			validityPeriod (value) {
				this.item.startDate = value.startDate
				this.item.endDate = value.endDate
			},
			'item.announced' (value) {
				if (value && this.item.announcementDate) {
					this.item.announcedAt = this.item.announcementDate
				}
			},
	        'toggle.activeTab' (value) {
	        	if (value == 4) {
	        		this.reloadReport()
	        	}
	        }
		}
	}
</script>

<style>
	.validity-input,
	.boxes-input {
		width: 290px;
	}
</style>